<script lang="ts">
	import { Tabs } from "bits-ui";
	import type { Snippet } from "svelte";
	import { onMount } from "svelte";

	interface TabDefinition {
		title: string;
		id: string;
		selector: string;
	}

	interface Props {
		dataSelector: string;
		children?: Snippet;
	}

	let { dataSelector, children }: Props = $props();

	let tabs: TabDefinition[] = $state([]);
	let tabContentElements: HTMLElement[] = $state([]);
	let activeTab = $state("");

	onMount(async () => {
		let dataElement = document.querySelector<HTMLElement>(dataSelector);
		tabs = JSON.parse(dataElement?.innerText ?? "[]");

		let elements: HTMLElement[] = [];
		for (let tab of tabs) {
			let element = document.querySelector<HTMLElement>(tab.selector);
			if (element) {
				elements.push(element);
			}
		}
		tabContentElements = elements;

		// bits-ui 2 has no equivalent of melt's `autoSet`, which is what opened the first tab
		// on mount under v0. Without this, nothing is selected until the reader clicks.
		activeTab = tabs[0]?.id ?? "";
	});
</script>

<Tabs.Root bind:value={activeTab}>
	<Tabs.List>
		{#snippet child({ props })}
			<div class="tabs is-toggle mb-0">
				<ul {...props}>
					{#each tabs as tab}
						<Tabs.Trigger value={tab.id}>
							{#snippet child({ props })}
								<li class:is-active={props["data-state"] === "active"} {...props}>
									<!-- The <li> carries bits-ui's role="tab"/tabindex; this anchor is Bulma's styling hook, and an <a> without href has no link role. -->
									<!-- svelte-ignore a11y_missing_attribute -->
									<a>{tab.title}</a>
								</li>
							{/snippet}
						</Tabs.Trigger>
					{/each}
				</ul>
			</div>
		{/snippet}
	</Tabs.List>
	{#each tabs as tab, index}
		<Tabs.Content class="tabs-content" value={tab.id}>
			{@html tabContentElements[index].outerHTML}
		</Tabs.Content>
	{/each}
</Tabs.Root>

<div class="is-hidden">
	{@render children?.()}
</div>
